import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup } from "vue"

import { computed, onMounted, onUnmounted, Raw, ref, useTemplateRef } from 'vue'
import { emitter } from '@/services/mitt'

import { checklist as _checklist, type ChecklistView } from '@/models/checklist'
import { Mixpanel } from '@/analytics/mixpanel'
import { storage } from '@/helpers/storage'
import { StorageKeys } from '@/helpers/storage.keys'
import { ChecklistDocs } from '@/models/checklist.types'

import ChecklistStep from './ChecklistStep.vue'
import ChecklistDocsPopup from './ChecklistDocsPopup.vue'
import ProgressRing from '@/components/ui/ProgressRing.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Checklist',
  props: {
    docs: {}
  },
  setup(__props: any) {



onMounted(() => {
  Mixpanel.trackChecklistShown()
  emitter.on('checklistShowPopup', showDocsPopup)
})

onUnmounted(() => {
  emitter.off('checklistShowPopup', showDocsPopup)
})

const checklist = ref<Raw<ChecklistView>>(_checklist()!)

const docsPopup = useTemplateRef('docsPopup')

// We store this in local storage so that it persists between sessions.
const isCollapsed = ref(
  storage.getItem(StorageKeys.checklistIsCollapsed19055) === 'true',
)

const freeStepTitle = computed(() =>
  checklist.value.stratum === 'trial' ? 'Start your trial' : 'Join Shortform',
)

const stepsToShow = computed(() =>
  // While the checklist is collapsed, only show the next step.
  isCollapsed.value ? [checklist.value.nextStep!] : checklist.value.stepsArray,
)

const progressText = computed(() => {
  // Add +1 from the free completed step that isn't a part of `ChecklistView`.
  const completedSteps = checklist.value.completedSteps.length + 1
  const totalSteps = checklist.value.stepsArray.length + 1

  return `${completedSteps}/${totalSteps}`
})

/**
 * Collapse / uncollapse the checklist.
 */
function toggleChecklist(): void {
  isCollapsed.value = !isCollapsed.value
  if (isCollapsed.value) {
    Mixpanel.trackChecklistDismissed()
    storage.setItem(StorageKeys.checklistIsCollapsed19055, 'true')
  } else {
    storage.removeItem(StorageKeys.checklistIsCollapsed19055)
  }
}

function showDocsPopup(): void {
  docsPopup.value?.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checklist", { 'checklist--collapsed': isCollapsed.value }])
  }, [
    _createElementVNode("button", {
      class: "checklist__head",
      onClick: toggleChecklist
    }, [
      _createVNode(ProgressRing, {
        class: "checklist__progress",
        progress: checklist.value.progressPercent
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(progressText.value), 1)
        ]),
        _: 1
      }, 8, ["progress"]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "checklist__head-text" }, [
        _createElementVNode("h2", { class: "checklist__title" }, "Getting started")
      ], -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["checklist__chevron", { 'checklist__chevron--collapsed': isCollapsed.value }])
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("span", { class: "iconfont iarrow-down" }, null, -1)
      ]))], 2)
    ]),
    _createVNode(_TransitionGroup, {
      class: "checklist__steps",
      name: "accordion-toggle",
      tag: "ul"
    }, {
      default: _withCtx(() => [
        (!isCollapsed.value)
          ? (_openBlock(), _createBlock(ChecklistStep, {
              key: 0,
              class: "checklist__step",
              step: {
          title: freeStepTitle.value,
          isCompleted: true,
        },
              docs: __props.docs
            }, null, 8, ["step", "docs"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepsToShow.value, (step) => {
          return (_openBlock(), _createBlock(ChecklistStep, {
            key: step.id,
            class: "checklist__step",
            step: step,
            docs: __props.docs,
            isNext: step.id === checklist.value.nextStep?.id
          }, null, 8, ["step", "docs", "isNext"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(ChecklistDocsPopup, {
      ref_key: "docsPopup",
      ref: docsPopup,
      checklist: checklist.value,
      docs: __props.docs.recommendations
    }, null, 8, ["checklist", "docs"])
  ], 2))
}
}

})